var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import PropTypes from 'prop-types';
import { MdArrowBack as Arrow } from 'react-icons/md';
import { MdHome } from 'react-icons/md';
import * as SharedStyle from '../../shared-style';

var breadcrumbStyle = {
  display: 'flex',
  flexWrap: 'wrap'
};

var breadcrumbTextStyle = {
  fontSize: '15px',
  cursor: 'pointer'
};

var breadcrumbLastTextStyle = _extends({}, breadcrumbTextStyle, {
  fontWeight: 'bolder',
  color: SharedStyle.SECONDARY_COLOR.main
});

var CatalogBreadcrumb = function CatalogBreadcrumb(_ref) {
  var names = _ref.names,
      isSidebar = _ref.isSidebar,
      onBackClick = _ref.onBackClick;


  var labelNames = names.map(function (name, ind) {

    var lastElement = ind === names.length - 1;
    var firstElement = ind === 0;

    return React.createElement(
      'div',
      { key: ind, style: { display: 'flex', alignItems: 'center', marginBottom: 5 } },
      React.createElement(
        'div',
        { style: !lastElement ? breadcrumbTextStyle : breadcrumbLastTextStyle, onClick: name.action || null },
        name.name === '/' ? React.createElement(MdHome, { style: { fontSize: 24 } }) : name.name
      ),
      React.createElement(
        'div',
        { style: { fontSize: '18px', display: 'flex', alignItems: 'center', padding: '0px 5px 0px 5px' } },
        !lastElement ? React.createElement(
          'span',
          null,
          '/'
        ) : null,
        ' '
      )
    );
  });

  return React.createElement(
    'div',
    { style: breadcrumbStyle },
    labelNames
  );
};

CatalogBreadcrumb.propTypes = {
  names: PropTypes.arrayOf(PropTypes.object).isRequired,
  isSidebar: PropTypes.bool,
  onBackClick: PropTypes.func
};

export default CatalogBreadcrumb;